import React from "react";
import IndexHeader from "app/shared-components/PageHeader";
import YouthSelectGroup from "app/shared-components/YouthSelectGroup";
import { authDataService } from "src/app/services/data/auth.data.service";
import { UserRole } from "src/app/@types/enums/user.roles";
import W4AllowanceCertificate from "./components/w4AllowanceCertificate";
import W4AllowanceWorksheet from "./components/w4AllowanceWorksheet";

export default function W4TaxFormIndexPage() {
  const isParent = authDataService.userRoleId == UserRole.Parent;

  return (
    <>
      <IndexHeader name="W4 Tax Form" update={false} add={false} noButtons />
      {isParent && (
        <div className="flex flex-col ml-24 mt-12">
          <YouthSelectGroup
            onProgramChange={() => {}}
            onYouthChange={() => {}}
          />
        </div>
      )}
      <W4AllowanceCertificate isReadOnly={isParent} />
      <W4AllowanceWorksheet isReadOnly={isParent} />
    </>
  );
}
